import InputOTP from './input-otp';

export default InputOTP;
export type * from './types';
